// extracted by mini-css-extract-plugin
export default {"card":"login_card__Y0xZl","logo":"login_logo__DkkXq"};